<template>
	<vs-row vs-w="12">
		<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
			<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
				<floating-buttons
					:titleHeader="$t('BreakTable.Action')"
					:saveText="isEditActive ? SubmitButtonTitleEdit : SubmitButtonTitleCreate"
					:cancelText="$t('MODULE_PERMISSION.Cancel')"
					@save="submitForm"
					@cancel="cancel"
				/>
			</div>
			<form id="skill-with-loading" class="vs-con-loading__container">
				<vx-card class="mt-2" :cardBorder="true" :noShadow="true">
					<vs-row>
						<vs-col vs-w="6" class="p-2">
							<vs-input
								name="name"
								class="w-full"
								v-model="skillItem.name"
								v-validate="'required'"
								:label="$t('BreakTable.Name')"
							/>
							<span class="text-danger text-sm" v-show="errors.has('name')">{{
								$t("Skills.Form.ValidMessages.Name")
							}}</span>
						</vs-col>
						<vs-col vs-w="6" class="p-2">
							<div class="w-full">
								<small>{{ $t("BreakTable.Description") }}</small>
								<vs-input
									name="description"
									class="w-full"
									v-model="skillItem.description"
									v-validate="'required'"
								/>
								<span class="text-danger text-sm" v-show="errors.has('description')">{{
									$t("Skills.Form.ValidMessages.Description")
								}}</span>
							</div>
						</vs-col>
					</vs-row>
				</vx-card>
				<vx-card class="mt-2" :cardBorder="true" :noShadow="true">
					<div class="vx-row p-2">
						<div class="vx-col w-full md:w-1/2 sm:w-1/1">
							<vs-divider style="font-size: 14px; font-weight: bold">{{
								$t("Routing.Buttons.AddVisitPoint")
							}}</vs-divider>
							<assigned-visit-point-list
								:isDemand="false"
								:isTypeService="false"
							></assigned-visit-point-list>
						</div>
						<div class="vx-col w-full md:w-1/2 sm:w-1/1">
							<vs-divider style="font-size: 14px; font-weight: bold">{{
								$t("VisitPoints.Add") + " " + $t("Vehicles.Vehicles")
							}}</vs-divider>
							<vehicle-assigned-list
								:search="true"
								:pagination="true"
								:isDemand="false"
								:componentParent="'SKILLS'"
							></vehicle-assigned-list>
						</div>
					</div>
				</vx-card>
			</form>
		</vs-col>
	</vs-row>
</template>
<script>
import DateUtils from "@/helpers/DateUtils.js";
import moduleSkills from "@/store/skills/moduleSkills.js";
import vSelect from "vue-select";
import AssignedVisitPointList from "@/components/visit-point/list/AssignedVisitPointList.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";
import VehicleAssignedList from "@/components/vehicle/list/VehicleAssignedList.vue";

export default {
	name: "SkillsForm",
	props: {
		isEditActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
		},
	},
	components: {
		vSelect,
		AssignedVisitPointList,
		FloatingButtons,
		VehicleAssignedList,
	},
	data() {
		return {
			skillItem: {},
			SubmitButtonTitle: "",
		};
	},
	computed: {
		title() {
			return this.$t("Skills.Skills");
		},
		SubmitButtonTitleCreate() {
			return this.$t("Save");
		},
		SubmitButtonTitleEdit() {
			return this.$t("Crud.Update");
		},
	},
	mounted() {
		if (this.isEditActive) {
			this.findSkillsById(this.$route.params.id);
		}
	},
	created() {
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
	},
	methods: {
		cancel() {
			this.$router.push("/dashboard/skills/list");
		},
		formatDates(dateString) {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			const newDate = new Date(dateString);
			return DateUtils.toDefaultDateTime(newDate, "HH:MM:SS");
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.isEditActive) {
						this.updateData();
					} else {
						this.saveData();
					}
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("MissingFieldTitle"),
						text: this.$t("MissingField"),
					});
					this.$vs.loading.close();
				}
			});
		},
		saveData() {
			this.skillItem["visit_point_id"] = this.$store.state.moduleVisitPoint.assignedVisitPoints.map(({id}) => id);
			this.skillItem["vehicle_id"] = this.$store.state.vehicle.assignedVehicles.map(({id}) => id);
			const params = {...this.skillItem};
			this.$vs.loading();
			this.$store
				.dispatch("moduleSkills/addSkill", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Skills.Messages.TitleConfirmCreate"),
						text: this.$t("Skills.Messages.TextConfirmCreate"),
					});
					this.$vs.loading.close();
					this.$router.push("/dashboard/skills/list");
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
					this.$vs.notify({
						color: "warning",
						title: this.$t("MissingFieldTitle"),
						text: this.$t("MissingField"),
					});
				});
		},
		updateData() {
			const payload = {
				name: this.skillItem.name,
				description: this.skillItem.description,
				visit_point_id: this.$store.state.moduleVisitPoint.assignedVisitPoints.map(({id}) => id),
				vehicle_id: this.$store.state.vehicle.assignedVehicles.map(({id}) => id),
			};
			this.$vs.loading();
			this.$store
				.dispatch("moduleSkills/updateItem", {id: this.skillItem.id, payload})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Skills.Messages.TitleConfirmUpdate"),
						text: this.$t("Skills.Messages.TextConfirmUpdate"),
					});
					this.$vs.loading.close();
					this.$router.push("/dashboard/skills/list");
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
				});
		},
		async findSkillsById(id) {
			this.$vs.loading({
				container: "#skill-with-loading",
				scale: 1,
				type: "sound",
			});
			this.$store
				.dispatch("moduleSkills/findSkillFilter", {
					id: [parseInt(id)],
					fields: ["id", "name", "description"],
				})
				.then((res) => {
					this.skillItem = res.records[0];
					this.$vs.loading.close("#skill-with-loading > .con-vs-loading");
					if (this.isEditActive) {
						let visitPointIds = res.records[0]["visit_point_id"];
						let vehicleIds = res.records[0]["vehicle_id"];
						if (visitPointIds && visitPointIds.length > 0) this.getVisitPoint(visitPointIds);
						if (vehicleIds && vehicleIds.length > 0) this.getAssignedVehicles(vehicleIds);
					}
				})
				.catch((err) => {
					this.$vs.loading.close("#skill-with-loading > .con-vs-loading");
					console.error(err);
				});
		},
		getAssignedVehicles(vehicle_ids) {
			const data = {
				id: vehicle_ids.map((id) => Number(id)),
				fields: ["id", "identification"],
				assign: true,
			};
			this.$store
				.dispatch("vehicle/findVehiclePaginated", data)
				.then((res) => {
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getVisitPoint(visitPointIds) {
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointsAssigned", {
					order_by: ["id"],
					sort: "desc",
					id: visitPointIds,
				})
				.then((res) => {
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_ASSIGNED_VISIT_POINT");
		this.$store.commit("vehicle/REMOVE_ALL_ASSIGNED_VEHICLE");
	},
};
</script>
